import { render, staticRenderFns } from "./AccountsSettingsEditModal.vue?vue&type=template&id=145c9340&"
import script from "./AccountsSettingsEditModal.vue?vue&type=script&lang=js&"
export * from "./AccountsSettingsEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports